<template>
  <div class="ConsignmentSummaryReportAmtTableTH">
    <Table width="500" border :columns="currencyColumnsList" :data="currencyData" v-if="isCurrencyData">
    </Table>
    <TablePage 
      :pageObj="pageObj"
      @changePage="changePage"
      :tableWidth="windowWidth"
      :columnsList="columnsList"
      :resultList="showData"
      v-if="isData">
    </TablePage>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "ConsignmentSummaryReportAmtTableTH",
  created() {
  },
  data() {
    return {
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      currencyColumnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("CURRENCY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'currency',
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("TOTAL_AMOUNT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'totalAmount',
          width: 80,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("TOTAL_ISSUE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'totalIssueQty',
          width: 80,
          align: "center",
        },
      ],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("PLANT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'plant',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PART_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'pn',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR_PN");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorPn',
          width: 120,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR_CODE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vnCode',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("INVOICE_NO");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'invoiceNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BEGIN_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'beginQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RETURN_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'returnQty',
          width: 100,
          sortable: true,
          align: "center",
        }, {
          renderHeader: (h, params) => {
            var text = this.$t("ISSUE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'issueQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BALANCE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'balanceQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("IQC_STOCK");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'iqcStock',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("AMOUNT");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'amount',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("CURRENCY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'currency',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_NUMBER");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("PO_ITEM");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'poItemNo',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("CONSIGN_PRICE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'consignPrice',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BEGIN_DATE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'beginDate',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("END_DATE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'endDate',
          width: 100,
          sortable: true,
          align: "center",
        },
      ],
    }
  },
  methods: {
    ...mapGetters(["getWindowsWidth"]),
    changePage(page) {
      this.pageObj.page = page - 1
    }
  },
  computed: {
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    isCurrencyData() {
      return this.currencyData && this.currencyData.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 70
    },
    showData() {
      return this.dataList.slice(this.pageObj.page, this.pageObj.page + this.pageObj.pageSize)
    }
  },
  watch: {
    dataList: {
      handler: function(newValue, oldValue) {
        this.pageObj.totalCount = newValue.length
        this.pageObj.totalPage = newValue.length / this.pageObj.pageSize == 0 ? parseInt(newValue.length / this.pageObj.pageSize) : parseInt(newValue.length / this.pageObj.pageSize) + 1
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    title: String,
    content: String,
    currencyData: Array,
    dataList: Array,
  },
}
</script>

<style scoped>

</style>